import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { ApolloClient } from '@apollo/client';
import DivisionList from 'components/divisions/division-list';


interface Props extends RouteComponentProps<any> {
  client: ApolloClient<any>;
}

const Divisions = ({
  match: {
    params: { orgId },
  },
}: Props) => (
    <>
      <div id="divisions" className="container hub-full-width">
        <div className="page-content u-xs-padXl u-flexExpandSides">
          <div className="page-content-header Grid u-flexAlignItemsCenter">
            <div className="Grid-cell u-xs-size1of2">
              <h1>Divisions</h1>
            </div>
          </div>
          <div className="page-content-body">
            <DivisionList organizationId={orgId} />
          </div>
        </div>
      </div>
    </>
  );

export default Divisions;
